import { Injectable } from "@angular/core";
import { DataService } from "@app/core/services/data.service";
import { CfsPutDto } from "@app/models";
import {
  CashRegister,
  CashRegisterExtendedGetDto,
  CashRegisterFilterPostDto,
  CashRegisterPairingStatusPostDto,
  CashRegisterStatusGetResponseDto,
  CashRegisterStatusPostDto
} from "cfs-communication-pack";
import { ApiListResponseModel, GridRequest, ItemShortInfoDto } from "clearline-api";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class CashRegisterService {
  serviceUrl = "cashregister";

  constructor(private http: DataService) {}

  getShort(locationIds: number[], includeLocationName = false): Observable<ItemShortInfoDto[]> {
    const query = locationIds.map((id) => `locationIds=${id}`).join("&") + (includeLocationName ? "&includeLocationName=true" : "");
    return this.http.get(`${this.serviceUrl}/short?${query}`);
  }

  getById(id: number): Observable<CashRegister> {
    return this.http.get(`${this.serviceUrl}/${id}`);
  }

  /** @deprecated */
  getAll(locationIds: number[]): Observable<CashRegister[]> {
    return this.http.post(`${this.serviceUrl}/bylocation`, { locationIds: locationIds });
  }

  grid(params: GridRequest<CashRegisterFilterPostDto>): Observable<ApiListResponseModel<CashRegisterExtendedGetDto[]>> {
    return this.http.postList(`${this.serviceUrl}/grid`, params);
  }

  getByActivationCode(activationCodeId: number): Observable<CashRegisterExtendedGetDto[]> {
    return this.http.get(`${this.serviceUrl}/byactivationcode?activationCodeId=${activationCodeId}`);
  }

  addCashRegister(locationId: number, cashregister: CashRegister): Observable<CashRegister> {
    return this.http.post(`${this.serviceUrl}/${locationId}`, cashregister);
  }

  updateCashRegister(cashregister: CashRegister): Observable<CashRegister> {
    return this.http.put(`${this.serviceUrl}/${cashregister.id}`, cashregister);
  }

  deleteCashRegister(id: number) {
    return this.http.delete(`${this.serviceUrl}/${id}`);
  }

  addCfs(id: number, cfs: CfsPutDto): Observable<CashRegister> {
    return this.http.put(`${this.serviceUrl}/cfs/${id}`, cfs);
  }

  getCashRegisterStatuses(ids: number[]): Observable<CashRegisterStatusGetResponseDto[]> {
    const query = ids?.length ? ids.map((id) => `cashRegisterIds=${id}`).join("&") : "";

    return this.http.get(`${this.serviceUrl}/status?${query}`);
  }

  getCashRegisterStatus(id: number): Observable<CashRegisterStatusGetResponseDto> {
    return this.http.get(`${this.serviceUrl}/${id}/status`);
  }

  setCashRegisterStatus(id: number, data: CashRegisterStatusPostDto): Observable<null> {
    return this.http.post(`${this.serviceUrl}/${id}/status`, data);
  }

  setCashRegisterPairingStatus(id: number, data: CashRegisterPairingStatusPostDto): Observable<null> {
    return this.http.post(`${this.serviceUrl}/${id}/status/pairing`, data);
  }
}
